import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { DataLayerService } from './data-layer.service';
import { GtmDataLayer } from './gtm.data-layer';
import { GooglePatternNumberFormatter } from '../services/google-pattern-number-formatter';

@NgModule({
    declarations: [],
    imports: [
        BrowserModule,
        CommonModule
    ],
    providers: [
        DataLayerService,
        GtmDataLayer,
        GooglePatternNumberFormatter
    ]
})
export class DataLayerModule {
    constructor(
        dataLayer: DataLayerService,
        gtm: GtmDataLayer
    ) {}
}



// WEBPACK FOOTER //
// /codebuild/output/src3659550778/src/src/app/shared/data-layer/data-layer.module.ts